const quizViewModeReducer = (state = false, action = {}) => {
    if (action.type === 'CHANGE_QUIZ_MODE') {
        return action.payload;
    }
    return state;
}

export default quizViewModeReducer;
